import { useActiveApp } from 'shared/hooks/useActiveApp'
import { useNavigationContext } from 'shared/hooks/useNavigationContext'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { WidgetAppTemplate } from '../templates/WidgetAppTemplate'

const FeedbackApp = () => {
  const { user } = useUserContext()
  const { feedbackState, setFeedbackState } = useNavigationContext()
  const { apps: availableApps } = useAvailableApps()

  const activeAppPath = useActiveApp()?.app.path

  return (
    <WidgetAppTemplate
      user={user}
      scope='feedback'
      envKey='feedbackApp'
      entryPath='./FeedbackApp'
      url={process.env.REACT_APP_FEEDBACK_APP_DEV_PATH}
      cdnUrl={process.env.REACT_APP_FEEDBACK_APP_CDN_URL}
      appProps={{
        user,
        feedbackState,
        setFeedbackState,
        availableApps: Object.values(availableApps),
        activeAppPath
      }}
      appName='Feedback'
    />
  )
}

export { FeedbackApp }
